.head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.head h1 {
  margin-bottom: 4px;
}

.periods {
  display: inline-flex;
  gap: 4px;
  padding: 4px;
  border: 1px solid var(--pill-line);
  border-radius: 999px;
  background: var(--pill-bg);
}

.period,
.periodActive {
  padding: 6px 14px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: var(--muted);
  font-size: 14px;
  white-space: nowrap;
}

.periodActive {
  background: var(--fill);
  background-image: var(--fill-gradient);
  color: var(--on-fill);
}

.tabs {
  display: flex;
  gap: 24px;
  margin-bottom: 20px;
  border-bottom: 1px solid var(--line);
  overflow-x: auto;
}

.tab,
.tabActive {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 8px 2px;
  border: 0;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  background: transparent;
  color: var(--muted);
  font-size: 15px;
  white-space: nowrap;
}

.tabActive {
  color: var(--text);
  border-bottom-color: var(--accent);
}

.kpis {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.split {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 16px;
}

.split > :global(.card-panel),
.stack > :global(.card-panel) {
  margin: 0;
}

.stack {
  display: grid;
  gap: 16px;
}

.caption {
  margin: 0 0 12px;
  color: var(--muted);
  font-size: 13px;
}

.scroll {
  overflow-x: auto;
}

.banner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
  padding: 12px 16px;
  border-radius: 16px;
  background: color-mix(in srgb, var(--danger) 14%, transparent);
}

.bar {
  display: flex;
  height: 14px;
  margin: 12px 0;
  border-radius: 999px;
  overflow: hidden;
  background: var(--pill-bg);
}

.big {
  font-family: var(--font-display);
  font-size: 36px;
}

.line {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 0;
  border-bottom: 1px solid var(--line);
  font-size: 14px;
}

.mono {
  font-family: ui-monospace, Menlo, Consolas, monospace;
  font-size: 13px;
}

.pager {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: flex-end;
}

.reasons {
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 14px;
}

.reasons legend {
  margin-bottom: 8px;
  color: var(--muted);
}

.reasons label {
  display: flex;
  align-items: center;
  gap: 8px;
}
